import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-notification-dialog',
    templateUrl: './notification-dialog.component.html',
    styleUrls: ['./notification-dialog.component.scss'],
    standalone: false
})
export class NotificationDialogComponent implements OnInit{

  title: string;
  content: string;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any) {
      this.title = data.title;
      this.content = data.content;
    }

  ngOnInit() {}
}
